import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useScale } from '../../../hooks/useScale';
import { useColors } from '../../../hooks/useColors';
import theme from '../../../common/theme';

const StatsModalStyles = () => {
  const { scale } = useScale();
  const { colors } = useColors();

  return useMemo(
    () =>
      StyleSheet.create({
        background: {
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.colors.modalBg,
        },
        container: {
          padding: scale(30),
          overflow: 'hidden',
          borderRadius: theme.radius.s,
          width: scale(340),
          rowGap: 4,
        },
        title: {
          color: colors.text,
          fontFamily: 'Inter-Regular',
          fontSize: scale(12),
          lineHeight: scale(20),
          paddingLeft: scale(4),
        },
        statsContainer: {
          backgroundColor: theme.colors.white,
          borderRadius: theme.radius.s,
          padding: scale(16),
        },
        statGroup: {
          flexDirection: 'row',
          alignItems: 'center',
          marginRight: scale(4),
          marginBottom: scale(8),
          justifyContent: 'space-between',
        },
        statLabel: {
          color: theme.colors.black,
          fontFamily: 'Inter-Regular',
          fontSize: scale(12),
          lineHeight: scale(20),
          marginRight: scale(4),
        },
        statValue: {
          color: theme.colors.lightBlueDark,
          fontFamily: 'Inter-Regular',
          fontSize: scale(12),
          lineHeight: scale(20),
        },
        longest: {
          color: theme.colors.red,
          fontFamily: 'Inter-Regular',
          fontSize: scale(12),
          lineHeight: scale(20),
        },
        separator: {
          width: scale(2),
          height: scale(34),
          backgroundColor: theme.colors.grey5,
          marginHorizontal: scale(8),
        },
      }),
    [colors, scale],
  );
};

export default StatsModalStyles;
